import constants from './constants';

/* APPLY CLASS NAMES
 * select all the elements found with the target selector...
 * ...then use the mode to determine whether or not to add or remove the effectClassName.
 */
const applyClassNames = (targetSelector, effectClassName, mode) => {
  const elements = [...document.getElementsByClassName(targetSelector)];
  elements.forEach((element) => {
    if (mode === 'add') {
      element.classList
        ? element.classList.add(effectClassName)
        : (element.className += effectClassName);
    } else if (mode === 'remove' && element.classList) {
      element.classList.remove(effectClassName);
    }
  });
};

const applyColumnStyling = (dataIndex, filterConfig) => {
  // Remove all sorting & filtering classes for the column with this dataIndex...
  /* ---------------------------------------------------------------------------------------- */
  applyClassNames(
    ['sort-by-' + dataIndex, 'sorted-' + constants.ascendingIdentifier].join(
      ' ',
    ),
    'sorted-' + constants.ascendingIdentifier,
    'remove',
  );
  applyClassNames(
    ['sort-by-' + dataIndex, 'sorted-' + constants.descendingIdentifier].join(
      ' ',
    ),
    'sorted-' + constants.descendingIdentifier,
    'remove',
  );
  applyClassNames(
    ['sort-by-' + dataIndex, 'filtered'].join(' '),
    'filtered',
    'remove',
  );

  /* ---------------------------------------------------------------------------------------- */

  // ...then add the appropriate classes for the filter config.
  /* ---------------------------------------------------------------------------------------- */
  filterConfig.filterState != constants.emptyFilterState
    ? applyClassNames('sort-by-' + dataIndex, 'filtered', 'add')
    : null;
  filterConfig.sortState.direction != constants.emptySortDirection
    ? applyClassNames(
        'sort-by-' + dataIndex,
        'sorted-' + filterConfig.sortState.direction,
        'add',
      )
    : null;
  /* ---------------------------------------------------------------------------------------- */
};

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const applyAllStyling = (filterConfigs) => {
  for (var dataIndex in filterConfigs) {
    applyColumnStyling(dataIndex, filterConfigs[dataIndex]);
  }
};

export default applyAllStyling;
